import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { init } from '@amplitude/analytics-browser';
import ReactDOM from 'react-dom/client';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';

import '@kajabi/sage-assets/dist/main.css';

import './index.css';
import reportWebVitals from './reportWebVitals';
import AiLeadGen from './pages/ai-lead-gen';

init('d4cd2a6ec851de7ab02d0f896c871056');

const config = {
  apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
  environment: process.env.REACT_APP_HONEYBADGER_ENV,
};

const root = ReactDOM.createRoot(
  document.getElementById('ai_lead_gen_portal') as HTMLElement
);

const honeybadger = Honeybadger.configure(config);

root.render(
  <HoneybadgerErrorBoundary honeybadger={honeybadger}>
    <React.StrictMode>
      <HelmetProvider>
        <AiLeadGen />
      </HelmetProvider>
    </React.StrictMode>
  </HoneybadgerErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
